import { i18n } from '@/app/service/i18n';

const networkStoreAssert = (bank) => {
  const bothChecked = bank.finance_pdv && bank.finance_rib;
  return !bothChecked ? null : i18n.global.tc('flash.bank_cannot_check_both');
};

export default networkStoreAssert;
